import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const MEASUREMENT_ID = "G-XK00JP1RLF";
const SCRIPT_ID = "ga4-gtag-script";
export const ANALYTICS_CONSENT_KEY = "cookie-consent";

let analyticsInitialized = false;
let lastTrackedLocation = "";
let previousLocation = "";

function isPrivatePath(pathname) {
  return pathname === "/bird" || pathname.startsWith("/bird/");
}

function readConsent() {
  try {
    const stored = JSON.parse(localStorage.getItem(ANALYTICS_CONSENT_KEY) || "null");
    return { analytics: stored?.analytics === true };
  } catch {
    return { analytics: false };
  }
}

function gtag(...args) {
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function globalGtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag(...args);
}

function isDebugSession() {
  return new URLSearchParams(window.location.search).get("ga_debug") === "1";
}

function initAnalytics(pathname) {
  if (isPrivatePath(pathname) || analyticsInitialized || !readConsent().analytics) return;

  const consent = readConsent();
  gtag("consent", "default", {
    ad_storage: "denied",
    analytics_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    wait_for_update: 500,
  });
  gtag("consent", "update", {
    analytics_storage: consent.analytics ? "granted" : "denied",
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
  });
  gtag("js", new Date());
  gtag("config", MEASUREMENT_ID, {
    send_page_view: false,
    ...(isDebugSession() ? { debug_mode: true } : {}),
  });

  if (!document.getElementById(SCRIPT_ID)) {
    const script = document.createElement("script");
    script.id = SCRIPT_ID;
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
    document.head.appendChild(script);
  }
  analyticsInitialized = true;
}

export function trackPageView(pathname, search = "", hash = "") {
  if (isPrivatePath(pathname)) return;
  initAnalytics(pathname);
  if (!readConsent().analytics) return;

  const pageLocation = `${window.location.origin}${pathname}${search}${hash}`;
  if (pageLocation === lastTrackedLocation) return;

  gtag("event", "page_view", {
    page_location: pageLocation,
    page_title: document.title,
    ...(isDebugSession() ? { debug_mode: true } : {}),
    ...(previousLocation ? { page_referrer: previousLocation } : {}),
  });
  previousLocation = pageLocation;
  lastTrackedLocation = pageLocation;
}

export function updateAnalyticsConsent(analytics) {
  localStorage.setItem(ANALYTICS_CONSENT_KEY, JSON.stringify({ analytics }));
  if (isPrivatePath(window.location.pathname) || !analytics) return;

  initAnalytics(window.location.pathname);
  gtag("consent", "update", {
    analytics_storage: analytics ? "granted" : "denied",
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
  });
  if (analytics) {
    trackPageView(window.location.pathname, window.location.search, window.location.hash);
  }
}

export function AnalyticsBootstrap() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname, location.search, location.hash);
  }, [location.hash, location.pathname, location.search]);

  return null;
}